import React, { useState, useRef, useMemo, useEffect } from 'react';
import styled from 'styled-components';
import InputModal from '../InputModal';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import {
  blankDefaultMsgRecoil,
  errorMsgRecoil,
  confirmMsgRecoil,
  privacyPolicyStateRecoil,
  privacyAgreementStateRecoil,
} from '../../atom/ModalAtom';
import CheckBox from '../../component/CheckBox';
import PrivacyPolicy from '../privacy/PrivacyPolicy';
import { authAPI } from '../../api/axiosIndex';
import { Icon } from '../../component/Icon';

const PrivacyAgreement = () => {
  const blankMsg = useRecoilValue(blankDefaultMsgRecoil);
  const setError = useSetRecoilState(errorMsgRecoil);
  const setConfirm = useSetRecoilState(confirmMsgRecoil);

  const setModalState = useSetRecoilState(privacyAgreementStateRecoil);
  const [privacyPolicyState, setPrivacyPolicyState] = useRecoilState(
    privacyPolicyStateRecoil,
  );

  const [checkIdArray, setCheckIdArray] = useState<string[]>([]);
  const [privacyPolicyCheck, setPrivacyPolicyCheck] = useState<boolean>(false);

  const handleConfirm = async () => {
    if (!privacyPolicyCheck) {
      setError('개인정보 수집 및 이용약관에 동의해주세요.');
      return;
    }

    try {
      await authAPI.putPrivacyPolicyAgreed(privacyPolicyCheck);
      setModalState(false);
      setConfirm('개인정보 수집 및 이용약관에 동의하였습니다.');
    } catch {
      setError('개인정보 수집 및 이용약관에 동의하는데 실패했습니다.');
    }
  };

  useEffect(() => {
    if (checkIdArray.includes('privacyPolicy')) {
      setPrivacyPolicyCheck(true);
    } else {
      setPrivacyPolicyCheck(false);
    }
  }, [checkIdArray]);

  return (
    <>
      <InputModal
        title="약관 동의"
        subText="약관 동의 후 서비스를 이용해 주세요."
        onCancel={() => setModalState(false)}
        onConfirm={handleConfirm}
        onlyConfirm={true}
      >
        <PrivacyWrap>
          <PrivacyBox>
            <CheckBox
              checkIdArray={checkIdArray}
              setCheckIdArray={setCheckIdArray}
              checkValue="privacyPolicy"
            />
            <button onClick={() => setPrivacyPolicyState(true)}>
              개인정보 수집 및 이용약관
              <span className="img-box">
                <Icon name="ArrowNextIcon" size="100%" color="#949494" />
              </span>
            </button>
          </PrivacyBox>
        </PrivacyWrap>
      </InputModal>
      {privacyPolicyState && <PrivacyPolicy />}
    </>
  );
};

export default PrivacyAgreement;

const PrivacyWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  box-sizing: border-box;
  padding: 0 8px;
  margin-top: 40px;
`;

const PrivacyBox = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  > button {
    font-size: 14px;
    color: #777;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 2px;
    > .img-box {
      width: 16px;
    }
  }
`;
